import { Apollo } from 'apollo-angular';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  createNgModule,
  Inject, Injector,
  LOCALE_ID,
  NgModuleRef,
  PLATFORM_ID,
  Type,
  ViewChild,
  ViewContainerRef,
  makeStateKey,
  TransferState
} from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { filter, map, switchMap, take, takeUntil, tap } from 'rxjs/operators';

import { CardWidgetPageResponse, ExapnsionPanels, ExpansionPanelItem, GameCategory } from 'src/app/apollo/models/base-models';
import { FRONT_PAGE_EXPANSION_PANEL } from 'src/app/apollo/front-page-games/front-page-games';
import { DomSanitizer } from '@angular/platform-browser';
import { ToggleMenuBackService } from 'src/app/services/utils/toggle-menu-back.service';
import { LoaderService } from 'src/app/services/utils/loader/loader.service';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { OpenDesktopDrawerService } from 'src/app/services/utils/open-desktop-drawer.service';
import { MinimizeSiteService } from 'src/app/services/utils/hide-footer.service';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { ClonerService } from 'src/app/services/utils/clone-object.service';
import { COUNTRY_ID, LICENCE } from 'src/app/global.tokens';
import { FilterGamesService } from 'src/app/services/utils/filter-games.service';
import { TranslationConfig } from 'src/app/utils/translate-config';
import { gameInfoTrx, activeBonusCategoryTrx, missionsTrx, promotionsTrx, reactivationTrx, searchGameTrx, tournamentsTrx } from 'src/app/router-translation.labels';
import { FrontPageGamesService } from 'src/app/services/page/front-games.service';
import { TournamentsCarouselComponent } from './tournaments-carousel/tournaments-carousel.component';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { BasePageComponentWithDialogs } from '../base-page/base-page.component';
import { MatDialog } from '@angular/material/dialog';
import { MissionsCarouselComponent } from './missions-carousel/missions-carousel.component';
import { combineLatest, firstValueFrom, timer } from 'rxjs';
import { WINDOW } from '@ng-web-apis/common';
import { DialogClosePreviousUrl } from 'src/app/services/utils/dialog-close-previouse-url.service';
import { PaymentListService } from 'src/app/services/payment/methods/payment-list.service';
import { BonusListService } from 'src/app/services/payment/bonus/bonus-list.service';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { LicenceService } from 'src/app/services/utils/licence.service';
import { PromotionCarouselComponent } from './promotion-carousel/promotion-carousel.component';
import { SearchConfig, swiperConfig, SearchConfigFilterItem, SearchGameService, SearchDataItem } from 'src/app/services/games/search-game.service';
import { ReactivationCarouselComponent } from './reactivation-carousel/reactivation-carousel.component';
import { loadChatScript } from 'src/app/utils/load-chat';
import { BonusQueueService } from 'src/app/services/wallet/bonus-queue.service';
import { DesktopService } from 'src/app/services/desktop/desktop.service';
// import { XmasCarouselComponent } from './xmas-carousel/xmas-carousel.component';
import SwiperCore, { Grid, SwiperOptions } from 'swiper';

const PROMOTIONS_KEY = makeStateKey<any[]>('PROMOTIONS_MOBILE_V1');
SwiperCore.use([Grid]);
@Component({
  selector: 'app-front-page',
  templateUrl: './front-page.component.html',
  styleUrls: ['./front-page.component.scss']
})
export class FrontPageComponent extends BasePageComponentWithDialogs implements AfterViewInit {

  // listen bonus
  isServer: boolean

  categories: GameCategory[];
  operators: GameCategory[];
  searchCategories: SearchConfigFilterItem[];
  searchSwiper: SearchConfigFilterItem;
  expansionPanel: ExpansionPanelItem[];
  public swiperCategories: GameCategory[];
  public activeBonusCategory: GameCategory[] = [];
  public tournamentsAllTrx = this.translationConfig.getTranslation(tournamentsTrx);
  public missionsAllTrx = this.translationConfig.getTranslation(missionsTrx);
  public promotionsAllTrx = this.translationConfig.getTranslation(promotionsTrx);
  public reactivationAllTrx = this.translationConfig.getTranslation(reactivationTrx);
  config: SwiperOptions = {
    grid: {
      rows: 2,
    },
    slidesPerView: 3,
    centerInsufficientSlides: false,
    spaceBetween: 10,
    lazy: true,
    preloadImages: false,
  };
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer,
    private elementRef: ElementRef,
    private apollo: Apollo,
    private toggleBackService: ToggleMenuBackService,
    private loadingService: LoaderService,
    public detectDeviceService: DetectDeviceService,
    public openDrawerService: OpenDesktopDrawerService,
    public minimizeSiteService: MinimizeSiteService,
    private frontPageGamesService: FrontPageGamesService,
    private cloneService: ClonerService,
    private FilterGamesService: FilterGamesService,
    protected translationConfig: TranslationConfig,
    private prevUrlService: DialogClosePreviousUrl,
    private paymentListService: PaymentListService,
    private bonusListService: BonusListService,
    private loginStatusService: LoginStatusService,
    protected licenceService: LicenceService,
    private searchGamesService: SearchGameService,
    private bonusService: BonusQueueService,
    private transferState: TransferState,
    private desktopService: DesktopService,
    @Inject(LOCALE_ID) public locale: string,
    @Inject(COUNTRY_ID) public countryId: string,
    @Inject(LICENCE) public licence: string,
    @Inject(PLATFORM_ID) private platformId,
    @Inject(WINDOW) protected windowRef: Window,

    private _injector: Injector,

    dialog: MatDialog,
    private detectDesktopService: DetectDeviceService,
  ) {
    super(dialog, detectDesktopService);

    this.isServer = isPlatformServer(this.platformId);

  }

  @ViewChild('tournaments', { static: false, read: ViewContainerRef })
  public tournamentsRef: ViewContainerRef;

  @ViewChild('missions', { static: false, read: ViewContainerRef })
  public missionsRef: ViewContainerRef;

  @ViewChild('promotion', { static: false, read: ViewContainerRef })
  public promotionRef: ViewContainerRef;

  @ViewChild('reactivation', { static: false, read: ViewContainerRef })
  public reactivationRef: ViewContainerRef;

  // @ViewChild('xmas', { static: false, read: ViewContainerRef })
  // public xmasRef: ViewContainerRef;

  protected isShowTournamentsModulePlaceholder = true;
  protected isShowRectivationModulePlaceholder = true;
  protected isShowXmasModulePlaceholder = true;
  protected isShowMissionsModulePlaceholder = true;
  protected isShowPromotionsModulePlaceholder = true;

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {

      timer(300).pipe(take(1)).subscribe(() => {
        const scrollPos = this.prevUrlService.getScrollPosition() || 0;
        this.windowRef.scrollTo(0, scrollPos);
        if (scrollPos > 0) {
          setTimeout(() => this.prevUrlService.reset(), 100);
        }
        this.loginStatusService.getIfUserLogged().pipe(take(1), takeUntil(this.unsubscribe)).subscribe(resp => {
          combineLatest({
            // here pay list income
            paymentResp: this.paymentListService.fetchPayment(resp.fullInfo?.country || 'en').pipe(
              filter(resp => resp.length !== 0),
              take(1)),
            // here bonus list income
            // bonusResp: this.bonusListService.fetchData().pipe(
            //   filter(resp => resp.length !== 0),
            //   take(1))
          }
          ).subscribe((resp) => { })
        })
      })
    }
  }

  private _openLazyLoadedComponent<T>(
    importedFile: T,
    componentToOpen: Type<TournamentsCarouselComponent>
  ): void {
    this.isShowTournamentsModulePlaceholder = false;
    const module: Type<T> = (importedFile as any)[Object.keys(importedFile)[0]];
    const moduleRef: NgModuleRef<T> = createNgModule(module, this._injector);
    this.tournamentsRef.createComponent(componentToOpen, { ngModuleRef: moduleRef });
  }
  private _openLazyLoadedComponentMissions<T>(
    importedFile: T,
    componentToOpenMissions: Type<MissionsCarouselComponent>
  ): void {
    this.isShowMissionsModulePlaceholder = false;
    const module: Type<T> = (importedFile as any)[Object.keys(importedFile)[0]];
    const moduleRef: NgModuleRef<T> = createNgModule(module, this._injector);
    this.missionsRef.createComponent(componentToOpenMissions, { ngModuleRef: moduleRef });
  }
  private _openLazyLoadedComponentPromotion<T>(
    importedFile: T,
    componentToOpenMissions: Type<PromotionCarouselComponent>
  ): void {
    this.isShowPromotionsModulePlaceholder = false;
    const module: Type<T> = (importedFile as any)[Object.keys(importedFile)[0]];
    const moduleRef: NgModuleRef<T> = createNgModule(module, this._injector);
    this.promotionRef.createComponent(componentToOpenMissions, { ngModuleRef: moduleRef });
  }
  private _openLazyLoadedComponentReactivation<T>(
    importedFile: T,
    componentToOpenMissions: Type<ReactivationCarouselComponent>
  ): void {
    this.isShowRectivationModulePlaceholder = false;
    const module: Type<T> = (importedFile as any)[Object.keys(importedFile)[0]];
    const moduleRef: NgModuleRef<T> = createNgModule(module, this._injector);
    this.reactivationRef.createComponent(componentToOpenMissions, { ngModuleRef: moduleRef });
  }

  // private _openLazyLoadedComponentXmas<T>(
  //   importedFile: T,
  //   componentToOpenXmas: Type<XmasCarouselComponent>
  // ): void {
  //   this.isShowXmasModulePlaceholder = false;
  //   const module: Type<T> = (importedFile as any)[Object.keys(importedFile)[0]];
  //   const moduleRef: NgModuleRef<T> = createNgModule(module, this._injector);
  //   this.xmasRef.createComponent(componentToOpenXmas, { ngModuleRef: moduleRef });
  // }

  ngOnInit(): void {
    if (this.isServer) {
      firstValueFrom(this.desktopService.staticPromotionData('promotions-front')).then(res => {
        const promoPage = PromotionCarouselComponent.filterPromoPagebyCountry(res as CardWidgetPageResponse, this.locale);
        const cardWidgetElements = promoPage.cardWidgetElements as unknown as any[];
        if (cardWidgetElements && cardWidgetElements.length > 0) {
          this.transferState.set(PROMOTIONS_KEY, cardWidgetElements);
          console.log('[FrontPage SSR (Mobile)] saved promotions to TransferState:', cardWidgetElements.length);
        }
      }).catch(err => console.error('[FrontPage (SSR)] promotions fetch error', err));
    }

    if (!isPlatformServer(this.platformId)) {
      import('../../components/tournaments/tournaments-carousel.dynamic.module').then((importedFile) => {
        const componentToOpen =
          importedFile.TournamentsCarouselDynamicModule.components.dynamicComponent;
        this._openLazyLoadedComponent(importedFile, componentToOpen);
      });

      import('../../components/missions/missions-carousel.dynamic.module').then((importedFile) => {
        const componentToOpenMissions =
          importedFile.MissionsCarouselDynamicModule.components.dynamicComponent;
        this._openLazyLoadedComponentMissions(importedFile, componentToOpenMissions);
      });

      import('../../components/front-page/promotion-carousel/promotion-carousel.dynamic.module').then((importedFile) => {
        const componentToOpenPromotions =
          importedFile.PromotionCarouselDynamicModule.components.dynamicComponent;
        this._openLazyLoadedComponentPromotion(importedFile, componentToOpenPromotions);
      });
      import('../../components/reactivation/reactivation-carousel.dynamic.module').then((importedFile) => {
        const componentToOpenMissions =
          importedFile.ReactivationCarouselDynamicModule.components.dynamicComponent;
        this._openLazyLoadedComponentReactivation(importedFile, componentToOpenMissions);
      });

      // import('../../components/xmas/xmas-carousel.dynamic.module').then((importedFile) => {
      //   const componentToOpenXmas =
      //     importedFile.XmasCarouselDynamicModule.components.dynamicComponent;
      //   this._openLazyLoadedComponentXmas(importedFile, componentToOpenXmas);
      // });
    }

    // this.loadingService.show();
    this.toggleBackService.hideBack();
    // this.titleService.setTitle($localize`:@@title-front-page:Lemon Casino - best games online`);

    this.bonusService.getActiveBonus().pipe(takeUntil(this.unsubscribe), take(1)).subscribe((res) => {

      if (!this.activeBonusCategory) {
        this.activeBonusCategory = [];
      }

      const games = res.includedGamesList?.[0]?.games || [];

      if (games.length > 0) {
        const newCategory: GameCategory = {
          icon: {url: "assets/icons/categories/icon-bonus-buy.svg"},
          id: res.bonus_ref,
          name: activeBonusCategoryTrx,
          displayName: res.bonus_name,
          game: games,
          displayType: 'square'
        };

        this.activeBonusCategory = [...this.activeBonusCategory, newCategory];
      }
    });

    this.frontPageGamesService.fetchData().pipe(
      takeUntil(this.unsubscribe),
    ).subscribe((response) => {
      let pageData = response.pagesCategories?.[0];

      if (!pageData) {
        return;
      }

      this.updateHeaderService.secondary_fallback = {
        title: pageData?.seo?.metaTitle ?? '',
        description: pageData?.seo?.metaDescription ?? ''
      };

      let categories = this.cloneService.deepClone<GameCategory[]>(pageData.categories);
      this.setSEOTags(pageData.seo?.metaTitle, pageData.seo?.metaDescription);

      this.categories = categories;

      this.operators = (response.operators?.[0] as any)?.categories || [];
      this.loadingService.hide();
    });

    this.apollo
      .watchQuery<ExapnsionPanels>({
        query: FRONT_PAGE_EXPANSION_PANEL,
        variables: {
          locale: this.locale,
          licenseName: this.licence
        }
      })
      .valueChanges.pipe(takeUntil(this.unsubscribe)).subscribe((response) => {
        const expansionPanelResponse = response.data.expansionPanels.find((panel) => panel.licence?.includes(this.licence) || panel.licence?.includes('all')) || response.data.expansionPanels[0];
        const resp: ExpansionPanelItem[] = this.cloneService.deepClone(expansionPanelResponse?.item);

        this.expansionPanel = resp?.map(item => {
          if (!!item && !!item.content) {
            item.content.text = item.content.html.replace(/<[^>]+>/g, '');
            item.content.safehtml = this.sanitizer.bypassSecurityTrustHtml(item.content.html);
            return item;
          }
        });
      });

    this.loginStatusService.getIfUserLogged().pipe(takeUntil(this.unsubscribe)).subscribe((status) => {
      let roles = status.fullInfo?.roles?.map((item: string) => item.toLowerCase());
      const hasVip = !!roles.find((item: string) => item.includes('vip')) || !!roles.some((item: string) => ["EX_VIP_ROW", "EX_VIP_PL", "EX_SVIP_ROW", "EX_SVIP_PL"].includes(item.toUpperCase()));
      if (hasVip) {
        loadChatScript(`vip-${this.locale}`, status.username, status.fullInfo.first_name);
      } else if (this.locale !== "pl") {
        loadChatScript(this.locale, status.username, status.fullInfo.first_name);
      }
      console.log("chat enabled 2")
    });
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    const componentPosition = this.elementRef?.nativeElement?.querySelector('#expansionPanel')?.offsetTop;
    if (!componentPosition) return;
    const scrollPosition = window.pageYOffset + window.innerHeight;
    if (scrollPosition >= componentPosition) {
      if (this.expansionPanel) {
        this.expansionPanel.forEach(element => {
          element.display = true;
        });
      }
    }
  }

  onFilterSelect(item: SearchDataItem) {
    this.searchGamesService.saveSearchHistory('');

    for (let category of this.searchCategories) {
      const categoryItem = category.data.find((_item) => _item.name === item.name);

      if (categoryItem) {
        categoryItem.selected = true;
        break;
      }
    }

    this.searchGamesService.setSearchFilters(this.searchCategories)
    this.router.navigate(['/' + searchGameTrx])
  }

  onSwiperCategoryClick(link: string) {
    this.router.navigate([link]);
  }

  onGameClick(game: any) {
    if (game?.systemName) {
      this.prevUrlService.setScrollPosition(this.windowRef.scrollY);
      this.router.navigate(["", this.translationConfig.getTranslation(gameInfoTrx), game?.systemName]);
    }
    //console.log('onGameClick game =>', game)
  }

}
